// extracted by mini-css-extract-plugin
module.exports = {"background":"GuideGrid_background__2CE3l","guidegrid":"GuideGrid_guidegrid__7HwpJ"};